import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

function CompetitorCard({ competitor, isInternal }) {
  const { name, logo } = competitor;

  return (
    <div
      className="cursor-pointer border-[3px] border-blue-700 bg-white rounded-lg p-4 flex flex-col items-center 
                 transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg 
                 hover:bg-blue-700 active:scale-95 group"
    >
      {logo ? (
        <img 
          src={logo} 
          alt={`${name} logo`} 
          className="w-28 h-28 mb-4 rounded-full object-cover"
        />
      ) : (
        <div className="w-28 h-28 mb-4 flex items-center justify-center bg-gray-200 rounded-full">
          <FontAwesomeIcon icon={faUser} className="text-5xl text-gray-500" />
        </div>
      )}
      <h2 className="text-xl font-bold text-center text-blue-700 transition-colors duration-300 group-hover:text-white">
        {name}
      </h2>
    </div>
  );
}

export default CompetitorCard;
